export default class PlanType {
  planTypeId?: number | null;
  description?: string | null;
  ageCategory?: string | null;

  public constructor(params: PlanType = {} as PlanType) {
    let { planTypeId = 0, description = null, ageCategory = null } = params;
    this.planTypeId = planTypeId;
    this.description = description;
    this.ageCategory = ageCategory;
  }
}
